(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initialiseMobileBundleTeasers = (scope = document) => {
    scope.querySelectorAll('[data-mobile-bundle-teaser]').forEach((teaser) => {
      if (teaser.dataset.mobileBundleTeaserReady === 'true') return;

      const productRoot = teaser.closest('.js-product');
      const bundle = productRoot?.querySelector('supplier-bedding-ladder, product-bundle-builder, towel-reward-builder');
      const target = bundle?.closest('[data-bundle-offer-target]');

      if (!bundle || !target?.id) return;

      teaser.dataset.mobileBundleTeaserReady = 'true';
      teaser.href = `#${target.id}`;

      if (bundle.matches('towel-reward-builder')) {
        const copy = teaser.querySelector('[data-mobile-bundle-teaser-copy]');
        if (copy && teaser.dataset.towelText) copy.textContent = teaser.dataset.towelText;
      }

      teaser.hidden = false;
      teaser.addEventListener('click', (event) => {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  initialiseMobileBundleTeasers();
  document.addEventListener('shopify:section:load', (event) => initialiseMobileBundleTeasers(event.target));

  } catch(e) { console.error(e); }
})();
})();
